export default __webpack_public_path__ + "static/flo2-7538022528cd2f725f59e7e3faa7a298.png";